let pwaUtilsPromise: Promise<typeof import('@ixigo/pwa')> | null = null;

function getPwaUtils() {
	if (!pwaUtilsPromise) {
		pwaUtilsPromise = import('@ixigo/pwa');
	}
	return pwaUtilsPromise;
}

/** Kick off the dynamic import early so the chunk is ready before user interaction. */
export function prefetchPwaUtils() {
	getPwaUtils();
}

export async function downloadPdfDocument(url: string): Promise<void> {
	try {
		const { PwaUtils } = await getPwaUtils();
		PwaUtils.downloadPdfDocument(url);
	} catch (error) {
		console.error('[pwa/pdf] Failed to load PwaUtils or download PDF:', error);
	}
}
